<section class="newsletter-form" aria-labelledby="newsletter-title">
    <h5 id="newsletter-title" class="newsletter-form__title">
        {{ "footer.subscribenewsletter" | T | uppercase }}
    </h5>

    <p class="newsletter-form__subtitle">
        <span>
            {{ "footer.allinfo" | T }}
        </span>
    </p>

    <form id="newsletterForm" name="newsletterForm" [formGroup]="newsletterForm" (ngSubmit)="onSubmit()" class="newsletter-form__form">
        <div class="newsletter-form__input-container">
            <div class="container-fluid">
                <div class="row">
                    <!-- Email Input -->
                    <div class="col-12 col-md-8">
                        <label for="email-input" class="visually-hidden">
                            {{ "footer.emailplaceholder" | T }}
                        </label>
                        <input id="email-input" 
                               class="newsletter-form__input" 
                               type="email" 
                               formControlName="email"
                               [placeholder]="'fast.insert_email' | T" 
                               aria-describedby="newsletter-subtitle"
                               placeholder="{{ 'newsletter.insert_email'|T }}" size="40" required data-cons-subject="email">
                        
                        @if (newsletterForm.get('email')?.touched && newsletterForm.get('email')?.errors?.['email']) {
                            <small class="text-danger d-block">{{ 'registrazione.invalid_email' | T }}</small>
                        }
                    </div>

                    <!-- Submit Button -->
                    <div class="col-12 col-md-4">
                        <button class="btn-newsletter mt-2 mt-md-0" 
                                type="submit" 
                                [disabled]="isSubmitting() || !newsletterForm.valid">
                            {{ (isSubmitting() ? '...' : 'footer.subscribenow' | T) }}
                        </button>
                    </div>

                    <!-- Checkboxes GDPR -->
                    <div class="col-12">
                        <div class="row">
                            <div class="col-12 pt-3">
                                <label style="float: left;" class="pr-2">
                                    <input type="checkbox" 
                                           id="newsletter_privacy" 
                                           formControlName="newsletter_privacy" 
                                           class="mb-0" 
                                           required data-cons-preference="legal_documents"> 
                                    {{ 'footer.newsletter_privacy' | T }}
                                </label>
                        
                                @if (newsletterForm.get('newsletter_privacy')?.touched && newsletterForm.get('newsletter_privacy')?.invalid) {
                                    <div style="clear: both;"><small class="text-danger d-block">{{ 'validation.accept_privacy' | T }}</small></div>
                                }
                            </div>
                            <div class="col-12">
                                <label>
                                    <input type="checkbox" 
                                           id="newsletter_ok" 
                                           formControlName="newsletter_ok" 
                                           class="mb-0" 
                                           required
                                           data-cons-preference="newsletter"> 
                                    {{ 'footer.newsletter' | T }}
                                </label>
                        
                                @if (newsletterForm.get('newsletter_ok')?.touched && newsletterForm.get('newsletter_ok')?.invalid) {
                                    <div style="clear: both;"><small class="text-danger d-block">{{ 'validation.accept_newsletter' | T }}</small></div>
                                }
                            </div>
                            <div class="col-12">
                                <app-iubenda-link tipo="privacy" [testo]="leggi_privacy"/>
                            </div>
                        </div>

                        <!-- Feedback finale -->
                        @if (message()) {
                            <div class="mt-3 alert" [ngClass]="message()?.type === 'success' ? 'alert-success' : 'alert-danger'">
                                {{ message()?.text }}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </form>
</section>